import cn from "../components/locals/chinese.json";
import en from "../components/locals/english.json";
import fr from "../components/locals/french.json";
import ja from "../components/locals/japanese.json";
import ko from "../components/locals/korean.json";
import ru from "../components/locals/russian.json";
import es from "../components/locals/spanish.json";
import { translationUtil } from "../i18";

const resources = { es, fr, en, ja, cn, ko, ru };
const langResources = translationUtil(resources);

export default langResources;
export const { t } = langResources;
